import React from 'react'
import root from '../shared/utils'

export default React.createClass({

  render: function() {
  let supportPage = root + '/common/latest/images/consumer/support-page'
  let arrowRight = root + '/common/latest/images/consumer/gray-arrow.png'

  let imgStyles = {
    maxWidth: '1.5em',
    maxHeight: '1.5em',
    paddingRight: '5px'
  }

  let arrowStyles = {
    ...imgStyles,
    marginTop: '5px'
  }

  let linksList = []
  for (let i = 0; i < this.props.data.length; i++) {
    if(i === 0){
      linksList.push(
      <div key={i}>
        <img className='img-responsive pull-left' alt='?' style={imgStyles} src={supportPage + '/' + this.props.data[i].icon + '.png'} />
        <a className='bold help faq-a' id={this.props.data[i].category} onClick={() => this.props.getQuestons(this.props.data[i].category)}>{this.props.data[i].label}</a>
        <img className='img-responsive pull-right' alt='>' style={arrowStyles} src={arrowRight} />
      </div>)
    }else{
    linksList.push(
      <div key={i}>
        <hr style={{borderColor: '#b9b9b9', marginBottom: 20}}/>
        <img className='img-responsive pull-left' alt='?' style={imgStyles} src={supportPage + '/' + this.props.data[i].icon + '.png'} />
        <a className='bold help faq-a' id={this.props.data[i].category} onClick={() => this.props.getQuestons(this.props.data[i].category)}>{this.props.data[i].label}</a>
        <img className='img-responsive pull-right' alt='>' style={arrowStyles} src={arrowRight} />
      </div>)
    }
  }
  return (
    <div>
      <div style={{margin:20}} className='faq'>
        {linksList}
      </div>
    </div>
  )
}})




// WEBPACK FOOTER //
// ./src/components/support/help-topics.jsx